import { render, staticRenderFns } from "./ItemNew.vue?vue&type=template&id=0f42489a&scoped=true&"
import script from "./ItemNew.vue?vue&type=script&lang=js&"
export * from "./ItemNew.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=0f42489a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42489a",
  null
  
)

export default component.exports